/*
    This file is part of Universal Sequences.
    Universal Sequences is free software: you can redistribute it and/or modif
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Universal Sequences is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import Web3 from 'web3';
import React, { Component } from 'react';
import axios from 'axios';
import SampledSound from 'components/SampledSound.js';
import SoundTagger from 'components/SoundTagger.js';
import ipfs from 'decentralized/Ipfs.js';
import ethereum from 'decentralized/ethereum.js';
import Sample from 'repos/Sample.js';
import UniversalNavigator from 'components/UniversalNavigator.js';
import {web3} from 'decentralized/web3.js';
import '../App.css';
import accounts from 'accounts/Accounts.js';
const metamaskInstalled = false;

class SoundUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: undefined,
            description: '',
            selectedFile: '',
            soundIds: [],
            soundIdToName: {},
            soundIdToTags: {},
            selectedSounds: {},
        };

        console.log('setting store', props.store);
        accounts.setStore(props.store);
        ethereum.crypto.store = props.store;
        accounts.setEthereum(ethereum);
        accounts.checkLogin();
        ethereum.guilds.initGuilds();
        ethereum.store = props.store;

        window.sequencerEngine = {
            store: props.store,
            ethereum: ethereum,
        };

        window.addEventListener("dragenter", function(e) {
            e.preventDefault();
            console.log('drag enter!');
            e.dataTransfer.effectAllowed = "none";
            e.dataTransfer.dropEffect = "none";
        }, false);
        
        window.addEventListener("dragover", function(e) {
            e.preventDefault();
            console.log('drag over!');
            e.dataTransfer.effectAllowed = "none";
            //e.dataTransfer.dropEffect = "none";
            return false;
        });

        window.addEventListener("drop", async (ev) => {
            console.log('dropped!');
            ev.preventDefault();
            ev.dataTransfer.effectAllowed = "none";
            ev.dataTransfer.dropEffect = "none";

            if (ev.dataTransfer.items) {
                // Use DataTransferItemList interface to access the file(s)
                for (var i = 0; i < ev.dataTransfer.items.length; i++) {
                    // If dropped items aren't files, reject them
                    if (ev.dataTransfer.items[i].kind === 'file') {
                        this.uploadFile(ev.dataTransfer.items[i].getAsFile());

                    }
                }
            } else {
                // Use DataTransfer interface to access the file(s)
                for (var i = 0; i < ev.dataTransfer.files.length; i++) {
                    console.log('... file[' + i + '].name = ' + ev.dataTransfer.files[i].name);
                }
            }
            return false;
        });
    }

    uploadFile(file) {
        let reader = new FileReader();
        reader.readAsArrayBuffer(file)
        reader.onloadend = async () => {
            console.log('read the file');
            console.log(reader.result);
            let hash = await ipfs.addArrayBuffer(reader.result);
            console.log('hash = ' + hash);
            this.state.soundIds.push(hash);
            console.log('file name = ' + file.name);
            this.state.soundIdToName[hash] = file.name;
            this.setState(this.state);
        };
    }
    
    onChange = (e) => {
        const state = this.state;
        
        
        state.name = e.target.files[0].name;
        
        switch (e.target.name) {
        case 'selectedFile':
            state.selectedFile = e.target.files[0];
            break;
        default:
            state[e.target.name] = e.target.value;
            state.name = e.target.value;
        }
        
        this.setState(state);
    }
    
    startTagging() {
        this.state.tagMode = true;
        this.setState(this.state);
    }

    async onSubmit(e) {
        e.preventDefault();
        console.log('on submit called');
        const { name, selectedFile } = this.state;

        let hash = await ipfs.addBlob(selectedFile);
        console.log('hash = ' + hash);
        this.state.soundIds.push(hash);
        this.state.soundIdToName[hash] = name;
        this.setState(this.state);

  }

    selectSound(soundId) {                           
        if (!this.state.selectedSounds[soundId]) {
            let selectedSounds = {... this.state.selectedSounds};
            selectedSounds[soundId] = true;
            this.setState({selectedSounds: selectedSounds});
        } else {
            let selectedSounds = {... this.state.selectedSounds};
            selectedSounds[soundId] = false;
            this.setState({selectedSounds: selectedSounds});
        }
    }

    loadTags() {
        var self = this;
        console.log('laoding tags');
        this.state.soundIds.map(async (soundId) => {
                    console.log('got tags for ' + soundId);
                    let tags = await new Sample(soundId).fetchTags();
                    self.state.soundIdToTags[soundId] = tags;
                    self.setState(self.state);
        });
    }

    saveToEthereum() {
        let promises:Promise<void>[] = [];
        let samples = [];

        for (let hash in this.state.soundIdToTags) {
            let tags = this.state.soundIdToTags[hash];
            let styles = [null, null, null, null];

            if (tags.length > 4) {
                tags = tags.slice(0, 4);
            } 
            for (let i=tags.length; i < 4; i++) {
                tags.push('');
            }

            let title = this.state.soundIdToName[hash];
            let date = new Date();

            let nullBytes32 = web3.utils.padLeft('0x0', 64);
            samples.push({
                ipfsHash: hash,
                title: title,
                videoId: '',
                tags: tags,
                styles: ['', '', '', ''],
                country: '',
                year: date.getFullYear(),
            });
        }

        ethereum.newSamplesWithMetadata(samples);
    }

    hasSelectedSounds() {
        let selectedSounds = this.state.selectedSounds;
        return  Object.keys(selectedSounds).some(
            s => selectedSounds[s]);
    }

    selectAll() {
        let selectedSounds = this.state.selectedSounds;
        let hasSelectedSounds = this.hasSelectedSounds();

        for (let i in this.state.soundIds) {
            let soundId = this.state.soundIds[i];
            selectedSounds[soundId] = !hasSelectedSounds;
        }
        this.setState({selectedSounds: selectedSounds});
    }

    addTag(tag) {
        console.log('add tag called');
        for (let id in this.state.selectedSounds) {
            if (!this.state.selectedSounds[id]) {
                continue;
            }
            if (id in this.state.soundIdToTags) {
                this.state.soundIdToTags[id].push(tag);
            } else {
                this.state.soundIdToTags[id] = [tag];
            }
        }

        console.log(this.state.soundIdToTags);

        this.setState(this.state);
    }

    onDropHandler(ev) {
        ev.stopPropagation();
        ev.preventDefault();

        ev.dataTransfer.effectAllowed = "none";
        ev.dataTransfer.dropEffect = "none";
    }

    dragOverHandler(event) {
        event.stopPropagation();
        event.preventDefault();
        event.dataTransfer.effectAllowed = "none";
        event.dataTransfer.dropEffect = "none";
        return false;
    }

    render() {
        const { description, selectedFile } = this.state;
        console.log('render called with soundIds = ' );
        console.log(this.state.soundIds);
        return (
            <div
              className="sound-upload-page">
              <UniversalNavigator store={this.props.store} showLogin={true}/>
              <div className='upload-pane'>
              <form onSubmit={(e) => this.onSubmit(e)}>
                <input
                  type="file"
                  name="selectedFile"
                  onChange={this.onChange}
                  />
                <button type="submit">Submit</button>
              </form>
              <div className="video-buttons-container">
                <div className='pink-button common-button' onClick={() => this.startTagging()}>TAG</div>
                <div className='pink-button common-button' onClick={() => this.saveToEthereum()}>SAVE</div>
                <div className='pink-button common-button' onClick={() => this.selectAll()}>
                  {this.hasSelectedSounds() ? 'UNSELECT ALL' : 'SELECT ALL'}</div>
              </div>
              <div className="sampled-sounds-container">
              {this.state.soundIds.map(
                  (soundId) =>
                      <SampledSound 
                            tags={this.state.soundIdToTags[soundId]}
                            title={this.state.soundIdToName[soundId]}
                            store={this.props.store}
                            isSelected={this.state.selectedSounds[soundId]}
                            onClickThumbnail={() => this.selectSound(soundId)}
                            soundId={soundId}/>
              )}
            </div>
                </div>
                <div className="description-pane">
                {this.state.tagMode ?
                 <SoundTagger
                 uploadMode={true}
                 soundIdToHash={this.state.soundIdToHash}
                 onUpdateTags={(tags) => this.addTag(tags)}
                 selectedSoundIds={this.state.selectedSoundIds}/> : ''}
            </div>
                </div>
        );
    }
}

export default SoundUpload;
